export default __webpack_public_path__ + "static/media/home-tracks-main.59633b6a.svg";